import { useDefaultObservableBoolean } from "observables/BooleanObservable";
import { useDefaultObservableString } from "observables/StringObservable";
import { createComponent } from "utils/libExtend/createComponent";

import { InputProps } from "./Input.props";
import { SForgotPasswordFormInput } from "./InputStyled/SForgotPasswordFormInput.styled";

export const Input = createComponent<InputProps>("Input", (props) => {
  const { service, placeholder, className = "", name, type = "text", dataTestId } = props;

  const value = useDefaultObservableString(service.state.value);
  const showError = useDefaultObservableBoolean(service.state.showError);

  return (
    <SForgotPasswordFormInput
      className={className}
      isError={showError}
      data-test-id={dataTestId}
      type={type}
      value={value}
      name={name}
      onChange={service.controller.onChange}
      placeholder={placeholder}
    />
  );
});
